//#region ../../packages/components/popper/src/constants.ts
const POPPER_INJECTION_KEY = Symbol("popper");
const POPPER_CONTENT_INJECTION_KEY = Symbol("popperContent");

//#endregion
export { POPPER_CONTENT_INJECTION_KEY, POPPER_INJECTION_KEY };
//# sourceMappingURL=constants.mjs.map